export const Svg_113 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M31.354 48.854h7.292v-7.291h7.292V34.27h-7.292v-7.292h-7.292v7.292h-7.291v7.291h7.291v7.292ZM11.667 61.25v-35L35 8.75l23.334 17.5v35H11.666Zm4.375-4.375h37.916v-28.73L35 14.366l-18.958 13.78v28.73Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.459}
        x2={48.595}
        y1={16.625}
        y2={54.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)